import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import rootAxios from 'requests/rootAxios';

export const fetchTrainingBypasses = createAsyncThunk(
  'trainingBypass/fetch',
  async (trainingType, { rejectWithValue }) => {
    try {
      const params = trainingType ? { trainingType } : {};
      const res = await rootAxios.get('/super-user/get-training-bypasses', { params });
      return res.data.data.bypasses;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const createTrainingBypass = createAsyncThunk(
  'trainingBypass/create',
  async (formData, { rejectWithValue }) => {
    try {
      const res = await rootAxios.post('/super-user/create-training-bypass', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return res.data.data.bypass;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const deleteTrainingBypass = createAsyncThunk(
  'trainingBypass/delete',
  async (id, { rejectWithValue }) => {
    try {
      await rootAxios.delete(`/super-user/delete-training-bypass/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const trainingBypassSlice = createSlice({
  name: 'trainingBypass',
  initialState: {
    bypasses: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrainingBypasses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainingBypasses.fulfilled, (state, action) => {
        state.loading = false;
        state.bypasses = action.payload;
      })
      .addCase(fetchTrainingBypasses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createTrainingBypass.fulfilled, (state, action) => {
        state.bypasses.unshift(action.payload);
      })
      .addCase(deleteTrainingBypass.fulfilled, (state, action) => {
        state.bypasses = state.bypasses.filter((b) => b._id !== action.payload);
      });
  },
});

export default trainingBypassSlice.reducer;
